// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__RIKqg","table":"styles_table__1nwvI"};